import { BiometricIdentityVerificationRequest } from "@wingspanhq/wingspan-api-sdk";

import { ContextItem, RequirementTableItemData } from "../../../../types";

export const getIdentityVerificationRequirementName = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  identityVerification: BiometricIdentityVerificationRequest | undefined
): string => {
  return requirement.name || "Identity verification";
};
